import { Util } from '@grandvisionhq/common';

const { replaceQueryParams  } = Util;
const replaceTimeSlotQueryParameters = (timeSlot)=>{
    const replaceParams = [
        {
            name: 'start',
            newValue: `${timeSlot.from.getTime()}`
        },
        {
            name: 'end',
            newValue: `${timeSlot.until.getTime()}`
        }, 
    ];
    const newUrl = replaceQueryParams(replaceParams, window.location.href);
    const historyStateKey = newUrl.replace(window.location.origin, '');
    // Update URL query parameters when picking a new slot
    // In order to work with Browser History API back/forth it
    // needs a decoded url string with a property key named 'as'
    window.history.replaceState({
        as: decodeURI(historyStateKey)
    }, '', newUrl);
};

export { replaceTimeSlotQueryParameters };
//# sourceMappingURL=replace-time-slot-query-parameters.js.map
